(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/params.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/params.js');

'use strict';

const showSessionExpiredDialog = () => {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'clock-simple',
    title: 'Det var ett tag sen',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du har varit inaktiv för länge - så vi börjar om på startsidan.'
    }],
    actions: [{
      title: 'Jag förstår'
    }]
  }));
};
const Params = () => {
  const {
    ParamHandler
  } = svs.lyckoplatsen.react;
  const params = [{
    key: 'sessionExpired',
    action: showSessionExpiredDialog
  }];
  return React.createElement(ParamHandler, {
    params: params
  });
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  Params
});

 })(window);